<template>
<div class="chapter">
<div class="inner_page">
<p class="pn"><a id="p27"></a>Part II</p>
<p class="pt">The Elements of Combat</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part_ii_the_elements_of_combat.vue?d147daf0